import axios from "axios";
import ConsoleLocalStorage from "../storage/storage";
import { DEV_CONSOLE_URL, APP_MANAGEMENT_URL } from "../config";
import { projectStatus } from "../util/helpers/statusHelper";
export default class DevAppAPI {
  dcInstance = axios.create({
    baseURL: DEV_CONSOLE_URL,
    headers: {
      Authorization: "Bearer " + ConsoleLocalStorage?.getAccessToken(),
      "x-organization-id": ConsoleLocalStorage?.getUser()?.organization,
    },
  });
  amInstance = axios.create({
    baseURL: APP_MANAGEMENT_URL,
    headers: {
      Authorization: "Bearer " + ConsoleLocalStorage?.getAccessToken(),
      "x-organization-id": ConsoleLocalStorage?.getUser()?.organization,
    },
  });

  dcCreateApp(projectid, data) {
    return this.dcInstance.post("application", data, {
      headers: {
        "x-project-id": projectid,
      },
    });
  }
  amCreateApp(projectid, data) {
    return this.amInstance.post("application", data, {
      headers: {
        "x-project-id": projectid,
      },
    });
  }

  getOneApp(appid) {
    return this.amInstance.get(`application/${appid}`);
  }

  getAllApps(projectid, platformType = "ALL", status, os = "android") {
    if (status !== projectStatus.pending.status) {
      if (platformType !== "ALL") {
        return this.amInstance.get(
          `project/${projectid}/application/list?platform=${platformType}&appOS=${os}`
        );
      } else {
        return this.amInstance.get(
          `project/${projectid}/application/list?appOS=${os}`
        );
      }
    } else {
      return false;
    }
  }
  getPlatformApps(projectid, platformType, os = "android") {
    return this.amInstance.get(
      `project/${projectid}/application/list?platform=${platformType}&appOS=${os}`
    );
  }
  getPendingApps() {
    const orgId = ConsoleLocalStorage.getOrganization()?.id;
    return this.amInstance.get(`application/${orgId}/pending-app`);
  }
  getAllOrgApps() {
    return this.amInstance.get("application/list/all");
  }
  updateApp(appid, data) {
    return this.amInstance.put(`application/${appid}`, data);
  }
  uploadGraphics(appid, data) {
    return this.amInstance.post(`application/${appid}/graphics`, data);
  }
  updateAppstoreGraphics(data) {
    return this.amInstance.post(`application/publish`, data);
  }
  releaseApp(appid, data) {
    return this.amInstance.post(`release/${appid}`, data);
  }
  getBuildStatus(appid) {
    return this.amInstance.get(`release/${appid}/list`);
  }
  deleteBuild(releaseid) {
    return this.amInstance.delete(`release/${releaseid}`);
  }
  publishBuild(releaseid, publishType) {
    return this.amInstance.post(`release/${releaseid}/stage/production`, {
      type: publishType,
    });
  }
  republish(releaseid, publishType) {
    return this.amInstance.post(`release/${releaseid}/publish`, {
      type: publishType,
    });
  }
  getKeys(data) {
    return this.amInstance.post(`/application/sdk/key`, data);
  }
  getAppKeys(id, keyType) {
    return this.amInstance.get(
      `/application/${id}/stage/${keyType}/sdk/key?pageNo=1&pageSize=10`
    );
  }
  getAppCreationConfig(tags = "consumer") {
    return this.amInstance.get(`/application/config?tags=${tags}`);
  }
}
